import { List } from 'antd';
import React, { useEffect, useState } from 'react';
import { useReminderFirebase } from './services/reminderFirebase';
import type { Reminder } from './types/reminder';

type ReminderWidgetStudentProps = {
  classId: string;
  studentId: string;
};

function formatTime(ts: number) {
  const d = new Date(ts);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function ReminderWidgetStudent({
  classId,
  studentId,
}: ReminderWidgetStudentProps) {
  const { subscribeRemindersForStudent } = useReminderFirebase();
  const [reminders, setReminders] = useState<Reminder[]>([]);

  useEffect(() => {
    if (!classId || !studentId) return () => {};
    const unsub = subscribeRemindersForStudent(classId, studentId, setReminders);
    return () => unsub();
  }, [classId, studentId]);

  const upcoming = reminders.filter((r) => r.status === 'active' && r.finalReminderTime > Date.now());

  return (
    <div style={{ padding: 16 }}>
      <div style={{ marginBottom: 8, fontWeight: 600 }}>
        Reminders set for you
      </div>
      {upcoming.length === 0 ? (
        <p style={{ color: '#666', margin: 0 }}>No upcoming reminders. Your teacher may add some.</p>
      ) : (
        <List
          size="small"
          dataSource={upcoming}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={item.message}
                description={
                  <>
                    Final: {formatTime(item.finalReminderTime)}
                    {item.softReminderTime != null && item.softReminderTime > Date.now() && (
                      <> · Soft: {formatTime(item.softReminderTime)}</>
                    )}
                  </>
                }
              />
            </List.Item>
          )}
        />
      )}
    </div>
  );
}
